export const Rajkot = {
    title: "Rajkot",
    title1: "(Saurashtra)",
    attractions: [
        {
            name: "Watson Museum",
            description: "A museum showcasing artifacts from colonial times and local history, offering insights into Rajkot's past.",
            location: "Jubilee Garden, Rajkot",
            timings: "10:30 AM to 5:30 PM (Closed on Wednesdays)",
            ticket: "INR 10 for Indians, INR 50 for Foreigners",
            bestTimeToVisit: "Afternoon",
            activities: [
                "Explore historical artifacts",
                "View ancient coins and manuscripts",
                "Learn about Rajkot’s heritage"
            ],
            mapLink: "https://maps.app.goo.gl/tAgJBozbpWErQXqXA",
        },
        {
            name: "Rotary Dolls Museum",
            description: "A unique museum featuring a vast collection of dolls from around the world, reflecting different cultures and traditions.",
            location: "Dr. Yagnik Road, Rajkot",
            timings: "10:00 AM to 6:00 PM",
            ticket: "INR 25 for Adults, INR 10 for Children",
            bestTimeToVisit: "Midday",
            activities: [
                "View an international collection of dolls",
                "Learn about global cultures",
                "Enjoy interactive exhibits"
            ],
            mapLink: "https://maps.app.goo.gl/FpxaoK1fbirvV2M16",
        },
        {
            name: "Kaba Gandhi No Delo",
            description: "The childhood home of Mahatma Gandhi, now converted into a museum displaying his early life and teachings.",
            location: "Ghee Kanta Road, Rajkot",
            timings: "9:00 AM to 12:00 PM, 3:00 PM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Late Afternoon",
            activities: [
                "Explore Gandhi’s childhood home",
                "View historical photographs and letters",
                "Attend cultural exhibitions"
            ],
            mapLink: "https://maps.app.goo.gl/eQmQFPRGQ6uNiJTW8",
        },
        {
            name: "Mahatma Gandhi Museum",
            description: "A museum dedicated to Mahatma Gandhi’s life, with exhibits showcasing his role in India’s freedom struggle.",
            location: "Jubilee Garden, Rajkot",
            timings: "10:00 AM to 5:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Learn about Gandhi’s ideology",
                "View rare photographs and letters",
                "Explore multimedia presentations"
            ],
            mapLink: "https://maps.app.goo.gl/cQsmzpjPz1UfWJqKA",
        },
        {
            name: "Jubilee Garden",
            description: "A scenic garden in the heart of Rajkot, featuring lush greenery, statues, and historical landmarks.",
            location: "Lakhajiraj Road, Rajkot",
            timings: "6:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Enjoy a peaceful walk",
                "Relax in the green surroundings",
                "Visit historical structures in the garden"
            ],
            mapLink: "https://maps.app.goo.gl/KRaBPV54sXYa4yHa6",
        },
        {
            name: "Aji Dam",
            description: "A major water reservoir providing scenic views and a relaxing environment.",
            location: "Aji Dam, Rajkot",
            timings: "6:00 AM to 7:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Months",
            activities: [
                "Enjoy picnic spots",
                "Bird watching",
                "Relax by the lake"
            ],
            mapLink: "https://maps.app.goo.gl/7CERHdEw9puRzJ8S7",
        },
        {
            name: "Pradhyuman Zoological Park",
            description: "A well-maintained zoo with a variety of animal species and lush green surroundings.",
            location: "Rajkot",
            timings: "9:00 AM to 6:00 PM",
            ticket: "INR 20 for Adults, INR 10 for Children",
            bestTimeToVisit: "Morning",
            activities: [
                "Explore wildlife exhibits",
                "Enjoy nature walks",
                "Photography"
            ],
            mapLink: "https://maps.app.goo.gl/UXYQhCEhkdVeVjyA8",
        },
        {
            name: "ISKCON Temple",
            description: "A beautiful temple dedicated to Lord Krishna, offering a spiritual retreat.",
            location: "Kalawad Road, Rajkot",
            timings: "4:30 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Attend Aarti and Bhajans",
                "Explore the temple architecture",
                "Enjoy spiritual discourses"
            ],
            mapLink: "https://maps.app.goo.gl/hYvePBbyPWjn7iQC6",
        },
        {
            name: "Swaminarayan Temple",
            description: "A beautifully carved temple dedicated to Lord Swaminarayan, known for its spiritual ambiance and intricate architecture.",
            location: "Kalavad Rd, near Mahila College, Vaishali Nagar, Rajkot",
            timings: "5:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Attend prayers and Aarti",
                "Explore intricate carvings",
                "Relax in the serene atmosphere"
            ],
            mapLink: "https://maps.app.goo.gl/7VKu9EQWupgztBLj7",
        },
        {
            name: "Race Course Grounds",
            description: "A popular recreational spot featuring a jogging track, amusement park, and sports facilities.",
            location: "Race Course Ring Road, Rajkot",
            timings: "Open 24 Hours",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning or Evening",
            activities: [
                "Enjoy a morning jog",
                "Visit amusement rides",
                "Play sports like cricket and football"
            ],
            mapLink: "https://maps.app.goo.gl/eXvzCSZYTs4zrjwx9",
        },
        {
            name: "Lang Library",
            description: "A historic library housing a vast collection of books, rare manuscripts, and literature.",
            location: "Rajkot",
            timings: "9:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Morning",
            activities: [
                "Browse rare books and manuscripts",
                "Read in a peaceful environment",
                "Explore historical literature"
            ],
            mapLink: "https://maps.app.goo.gl/C5rKQZggqo1XGYMC8",
        },
        {
            name: "Khambhalida Caves",
            description: "Ancient Buddhist rock-cut caves featuring sculptures and intricate carvings from the 4th century.",
            location: "Gondal, near Rajkot",
            timings: "8:00 AM to 6:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Winter Months",
            activities: [
                "Explore ancient Buddhist sculptures",
                "Enjoy scenic views",
                "Photography"
            ],
            mapLink: "https://maps.app.goo.gl/BdMpFpz9GYqvkNH87",
        }
    ]
};
